import { motion } from "framer-motion";
import SiteLayout from "@/components/SiteLayout";
import { ABOUT_CONTENT } from "@/data/siteContent";
import { usePageMeta } from "@/hooks/usePageMeta";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
  viewport: { once: true },
};

const AboutPage = ({ language = "fr" }) => {
  const content = ABOUT_CONTENT[language] || ABOUT_CONTENT.fr;
  const metaTitle = content.title || "À propos";
  const metaDescription = content.subtitle || "Entreprise de pavé uni.";

  usePageMeta(metaTitle, metaDescription);

  return (
    <SiteLayout language={language}>
      <section className="py-16 md:py-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-24 space-y-10">
          <motion.div {...fadeUp} className="space-y-4">
            <p className="text-xs uppercase tracking-[0.4em] text-secondary" data-testid="about-eyebrow">
              {language === "fr" ? "Entreprise" : "Company"}
            </p>
            <h1 className="text-3xl md:text-5xl font-bold text-primary" data-testid="about-title">
              {content.title}
            </h1>
            <p className="text-lg text-muted-foreground" data-testid="about-subtitle">
              {content.subtitle}
            </p>
          </motion.div>

          <div className="space-y-6">
            {content.paragraphs.map((paragraph, index) => (
              <motion.p
                {...fadeUp}
                key={paragraph}
                className="text-muted-foreground"
                data-testid={`about-paragraph-${index + 1}`}
              >
                {paragraph}
              </motion.p>
            ))}
          </div>

          <motion.div {...fadeUp} className="space-y-4">
            <h2 className="text-2xl font-bold text-primary" data-testid="about-values-title">
              {content.valuesTitle}
            </h2>
            <ul className="grid gap-3 md:grid-cols-2" data-testid="about-values-list">
              {content.values.map((value, index) => (
                <li
                  key={value}
                  className="border border-border bg-white px-4 py-3 text-sm"
                  data-testid={`about-value-${index + 1}`}
                >
                  {value}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.p
            {...fadeUp}
            className="font-accent text-xl text-primary"
            data-testid="about-quote"
          >
            “{content.quote}”
          </motion.p>
        </div>
      </section>
    </SiteLayout>
  );
};

export default AboutPage;